// extracted by mini-css-extract-plugin
export default {"card":"PersonCard_card__dmw0W","icon":"PersonCard_icon__n7522","play":"PersonCard_play__aG9a1","title":"PersonCard_title__k2gGu","description":"PersonCard_description__2DmTV"};